const DEMO_UUID_PREFIX = "00000000-de00-";

/** A valid uuid for the `index`th fake object of a kind; every one starts with the demo prefix. */
export const toBusyClosesDemoId = (index: number) =>
    `${DEMO_UUID_PREFIX}4000-8000-${index.toString(16).padStart(12, "0")}`;

/** Whether an id, bare or inside a prefixed row id (`close:<uuid>`), names a busy closes demo object. */
export const isBusyClosesDemoId = (id: string | null | undefined): boolean =>
    id?.includes(DEMO_UUID_PREFIX) ?? false;
